export enum TagBrandingType {
  Marriott = 'marriott',
  Civitatis = 'civitatis',
}
